// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentType, type ComponentProps } from 'react';
import initial from 'lodash/initial';
import last from 'lodash/last';
import ReposIcon from '@atlaskit/icon/glyph/bitbucket/repos';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { BitbucketIcon } from '@atlaskit/logo';
import type { NavLink } from '@atlassian/jira-navigation-types/src/types.tsx';
import type { ShortcutItem } from '../types.tsx';

const getLinkParts = (linkId: string): string[] => linkId.split(':')[1].split('.');
// @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
const SizedBitBucketIcon = (props) => <BitbucketIcon {...props} size="small" />;

export const getIcon = (
	iconName?: string,
): ComponentType<
	JSX.LibraryManagedAttributes<
		// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
		typeof BitbucketIcon | typeof ReposIcon | typeof ShortcutIcon,
		// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
		ComponentProps<typeof BitbucketIcon | typeof ReposIcon | typeof ShortcutIcon>
	>
> => {
	switch (iconName) {
		case 'bitbucket':
			return SizedBitBucketIcon;
		case 'github':
		case 'repos':
			// @ts-expect-error - TS2322 - Type 'typeof default' is not assignable to type 'ComponentType<GlyphProps | Props | (Pick<GlyphProps, "testId" | "primaryColor" | "secondaryColor"> & Partial<Pick<GlyphProps, "label" | "size">> & Partial<...>) | (Pick<...> & ... 1 more ... & Partial<...>)>'.
			// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
			return ReposIcon;
		default:
			// @ts-expect-error - TS2322 - Type 'typeof default' is not assignable to type 'ComponentType<GlyphProps | Props | (Pick<GlyphProps, "testId" | "primaryColor" | "secondaryColor"> & Partial<Pick<GlyphProps, "label" | "size">> & Partial<...>) | (Pick<...> & ... 1 more ... & Partial<...>)>'.
			// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
			return ShortcutIcon;
	}
};

// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
export const getIdFromLinkId = (linkId: string): string => last(getLinkParts(linkId));

export const getIdFromLinkIdV4 = (linkId: string): string => linkId;

export const getShortcutTypeFromLinkId = (linkId: string): string =>
	initial(getLinkParts(linkId)).join('.');

export const getItemFromLink = (link: NavLink): ShortcutItem => {
	const { id: linkId, icon } = link;
	const id = getIdFromLinkId(linkId);
	const shortcutType = getShortcutTypeFromLinkId(linkId);
	const target = link.target ?? '_blank';
	const Icon = getIcon(icon);

	return {
		id,
		icon,
		legacyId: linkId,
		target,
		shortcutType,
		text: link.name,
		before: Icon,
		href: link.url,
		canEdit: link.canEdit,
		showSync: link.showSync,
		itemType: 'shortcut',
	};
};
